import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { motion } from "framer-motion";
import Navbar from "../componenets/Navbar";
import Footer from "../componenets/Footer";

const SignUp = () => {
  const [role, setRole] = useState<"client" | "agent">("client");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    fullName: "",
    licenseNumber: "",
    commodities:"",
    company: "",
    location: "" // Added location to state
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth, 
        formData.email, 
        formData.password
      );
      const user = userCredential.user;

      const userData = {
        uid: user.uid,
        fullName: formData.fullName,
        email: formData.email,
        role: role,
        company: formData.company,
        createdAt: new Date().toISOString(),
        status: role === "agent" ? "pending" : "approved",
        paymentStatus: "unpaid", 
        // Logic: Save agent-specific details including location
        ...(role === "agent" && { 
            licenseNumber: formData.licenseNumber,
            location: formData.location,
            commodities: formData.commodities 
        })
      };

      await setDoc(doc(db, "users", user.uid), userData);
      
      if (role === "agent") {
        alert("Account created! Once an admin approves your license and you complete the registration fee, your dashboard will be activated.");
        navigate("/"); 
      } else {
        alert("Welcome to Sri Lanka Imports Tariff Search! Subscribe to premium to unlock the full Agent Directory.");
        navigate("/");
      }
    } catch (err: any) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="auth-container">
        <motion.div 
          initial={{ y: 20, opacity: 0 }} 
          animate={{ y: 0, opacity: 1 }} 
          className="auth-card"
        >
          <h2>Create Account</h2>
          
          <div className="role-selector">
            <button 
              className={role === "client" ? "active" : ""} 
              onClick={() => setRole("client")}
            >
              I am a Client
            </button>
            <button 
              className={role === "agent" ? "active" : ""} 
              onClick={() => setRole("agent")}
            >
              I am an Agent
            </button>
          </div>

          <form onSubmit={handleSignUp}>
            <div className="input-group">
              <input 
                type="text" 
                placeholder="Full Name" 
                required 
                onChange={(e) => setFormData({...formData, fullName: e.target.value})} 
              />
              <input 
                type="email" 
                placeholder="Email Address" 
                required 
                onChange={(e) => setFormData({...formData, email: e.target.value})} 
              />
              <input 
                type="text" 
                placeholder="Company Name (Optional)" 
                onChange={(e) => setFormData({...formData, company: e.target.value})} 
              />
              
              {role === "agent" && (
                <motion.div 
                  initial={{ opacity: 0, height: 0 }} 
                  animate={{ opacity: 1, height: "auto" }}
                  className="conditional-fields"
                >
                  <input 
                    type="text" 
                    placeholder="Customs License Number" 
                    required 
                    onChange={(e) => setFormData({...formData, licenseNumber: e.target.value})} 
                  />
                  {/* NEW: Location Input for Agents */}
                  <input 
                    type="text" 
                    placeholder="Operating Location (e.g. Colombo Port, Katunayake)" 
                    required 
                    onChange={(e) => setFormData({...formData, location: e.target.value})} 
                  />
                  <input
                    type="text"
                    placeholder="Specialized Commodities"
                    required
                    onChange={(e)=> setFormData({...formData, commodities: e.target.value})}
                  />
                  <div className="payment-notice-box">
                    <p>ℹ️ <strong>Agent Activation:</strong> Following admin approval, a one-time activation fee of Rs. 5,000.00 is required to list your services.</p>
                  </div>
                </motion.div>
              )}

              {role === "client" && (
                <div className="payment-notice-box client-notice">
                  <p>✨ <strong>Premium Access:</strong> Standard search is free. Subscribe later to unlock contact details of verified Clearing Agents.</p>
                </div>
              )}

              <input 
                type="password" 
                placeholder="Password" 
                required 
                onChange={(e) => setFormData({...formData, password: e.target.value})} 
              />
            </div>
            
            <button type="submit" className="primary-btn" disabled={loading}>
              {loading ? "Creating Account..." : `Sign Up as ${role === "client" ? "Client" : "Agent"}`}
            </button>
          </form>
          
          <p className="auth-footer-text">
            Already have an account? <span onClick={() => navigate("/signin")}>Login</span>
          </p>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
};

export default SignUp;